// init_swiper.js

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Export Swiper initialization function
const initSwiper = () => {
  if(!document.querySelector('.km_horizontal-slider')) return;
  const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination, Autoplay],
    loop: false, // Enable continuous loop mode
    slidesPerView: 2, // Display 2 slides per view
    slidesPerGroup: 1, // Move 1 slide per group
    spaceBetween: 16, // 16px gap between slides
    autoHeight: false, // Adjust height automatically based on content
    grabCursor: true, // Show grab cursor to indicate draggable area
    slideToClickedSlide: false, // Enable slide to the clicked slide
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar', // Use a progress bar for pagination
      clickable: true, // Make pagination clickable
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: false,
    preloadImages: false, // Verzögert das Laden von Bildern, um Layout-Sprünge zu vermeiden
    observer: true,
    observeParents: true,
    // Breakpoints für responsive Einstellungen
    breakpoints: {
      0: { // Mobile Geräte
        slidesPerView: 1, // 1 Slide per View für kleinere Bildschirme
        spaceBetween: 10, // Weniger Abstand auf mobilen Geräten
      },
      992: { // Tablets und größere Bildschirme
        slidesPerView: 2, // 2 Slides per View für größere Bildschirme
        spaceBetween: 16, // Abstand von 16px für größere Bildschirme
      },
    },
    on: {
      init: function () {
        document.querySelector('.swiper').style.visibility = 'visible'; // Swiper nach Initialisierung anzeigen
      }
    }
    // Additional Swiper options...
  });
};

export default initSwiper;


